<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-card class="overflow-hidden">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <customer-autocomplete-filter
                  :fatherEditedCustomer="filterWorkDone"
                  :editedCustomerIndex="-1"
                  :customerName="'quotation_customer_number'"
                  @setFilterCustomer="setDoneFilterCustomer"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <v-text-field
                  :label="$t('quotation_license_plate')"
                  v-model="filterWorkDone.LicensePlate"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <v-autocomplete
                  :items="maintenanceEngineers"
                  :label="$t('installation_notice_engineer')"
                  v-model="filterWorkDone.MaintenanceEngineer"
                  item-text="NickName"
                  item-value="UserName"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <v-autocomplete
                  :items="allSpecialNeedList"
                  item-text="Name"
                  item-value="Id"
                  :label="$t('quotation_special_need')"
                  v-model="filterWorkDone.SpecialNeedId"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <date-picker
                  :dateName="'installation_acceptance_start_done_time'"
                  :isAllTextFieldDisabled="false"
                  @setDate="setStartDoneTime"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <date-picker
                  :dateName="'installation_acceptance_end_done_time'"
                  :isAllTextFieldDisabled="false"
                  @setDate="setEndDoneTime"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="getDoneWork" color="primary">{{
              $t('quotation_item_new_install_search')
            }}</v-btn>
          </v-card-actions>
        </v-card>
        <v-data-table
          :headers="engineerDoneWorkDataTableHeaders"
          :items="doneList"
          class="elevation-1 mt-5"
          :loading="isDoneLoading"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          sort-by="CreateTime"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('engineer_tab_three_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog v-model="isShowWatchEngineerWorkDialog" fullscreen persistent>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('common_look') }}</span>
                  </v-card-title>
                  <v-tabs>
                    <v-tab href="#tab-1">{{ tabOneTitle }}</v-tab>
                    <v-tab
                      href="#tab-2"
                      v-if="
                        editedEngineerWork.FixFileNameList &&
                          editedEngineerWork.FixFileNameList.length > 0
                      "
                      >{{ $t('repair_fix_photo') }}</v-tab
                    >
                    <v-tab
                      href="#tab-3"
                      v-if="
                        editedEngineerWork.FileNameList &&
                          editedEngineerWork.FileNameList.length > 0
                      "
                      >{{ $t('installation_acceptance_engineer_photo') }}</v-tab
                    >
                    <v-tab
                      href="#tab-4"
                      v-if="
                        editedEngineerWork.NumberType === 9 &&
                          editedEngineerWork.FixType !== 1 &&
                          editedEngineerWork.FixType !== 2 &&
                          editedEngineerWork.FixType !== 12
                      "
                      >{{ $t('engineer_in_car_item') }}</v-tab
                    >
                    <v-tab href="#tab-5" v-if="editedEngineerWork.NumberType === 9">{{
                      $t('quotation_tab_third')
                    }}</v-tab>
                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.Number"
                                  :label="$t('engineer_number')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="turnDate"
                                  :label="$t('installation_notice_create_time')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  :items="allSpecialNeedList"
                                  item-text="Name"
                                  item-value="Name"
                                  :label="$t('quotation_special_need')"
                                  disabled
                                  v-model="editedEngineerWork.SpecialNeedList"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  return-object
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.Brand"
                                  disabled
                                  label="廠牌/車型"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerNumber"
                                  :label="$t('quotation_customer_number')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerName"
                                  :label="$t('quotation_shortname')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerFullName"
                                  :label="$t('quotation_full_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CarPlace"
                                  :label="$t('quotation_car_place')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_first_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.FirstContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.FirstContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_second_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.SecondContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.SecondContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_third_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.ThirdContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.ThirdContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <ValidationObserver ref="work">
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedEngineerWork.LicensePlate"
                                    :label="$t('quotation_license_plate')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedEngineerWork.OriginalLicensePlate"
                                    :label="$t('quotation_original_license_plate')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    :items="maintenanceEngineers"
                                    item-text="NickName"
                                    item-value="UserName"
                                    :label="$t('installation_notice_engineer')"
                                    v-model="editedEngineerWork.MaintenanceEngineers"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    disabled
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedEngineerWork.Point"
                                    :label="$t('installation_notice_point')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="turnDoneTime"
                                    :label="$t('installation_acceptance_done_time')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </ValidationObserver>
                          </v-container>
                        </v-card-text>

                        <!-- 維修工單 -->
                        <v-data-table
                          :headers="workItemDataTableHeaders"
                          :items="editedEngineerWork.EngineerWorkItems"
                          class="elevation-1 my-5 mx-5"
                          :search="searchWorkItems"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          v-if="
                            editedEngineerWork.NumberType === 9 &&
                              editedEngineerWork.FixType !== 1 &&
                              editedEngineerWork.FixType !== 2 &&
                              editedEngineerWork.FixType !== 12
                          "
                          :item-class="isOutOfWarrantyClass"
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title>{{
                                $t('engineer_item_repair_item_title')
                              }}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="searchWorkItems"
                                append-icon="mdi-magnify"
                                :label="$t('quotation_item_new_install_search')"
                                single-line
                                hide-details
                                clearable
                              ></v-text-field>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.RemoveItem.InstallPosition`]="{ item }">
                            {{ turnData(item.RemoveItem.InstallPosition) }}
                          </template>
                          <template v-slot:[`item.RemoveItem.WorkType`]="{ item }">
                            {{ turnWorkTypeName(item.RemoveItem.WorkType) }}
                          </template>
                          <template v-slot:[`item.ReturnItem.InstallPosition`]="{ item }">
                            {{ turnData(item.ReturnItem.InstallPosition) }}
                          </template>
                          <template v-slot:[`item.ReturnItem.WorkType`]="{ item }">
                            {{ turnWorkTypeName(item.ReturnItem.WorkType) }}
                          </template>
                        </v-data-table>
                        <!-- 拆機工單 -->
                        <v-data-table
                          :headers="removeWorkItemDataTableHeaders"
                          :items="editedEngineerWork.EngineerWorkItems"
                          class="elevation-1 my-5 mx-5"
                          :search="searchWorkItems"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          v-if="
                            editedEngineerWork.NumberType === 9 &&
                              (editedEngineerWork.FixType === 1 ||
                                editedEngineerWork.FixType === 2 ||
                                editedEngineerWork.FixType === 12)
                          "
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title>{{
                                $t('engineer_item_repair_item_remove_title')
                              }}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="searchWorkItems"
                                append-icon="mdi-magnify"
                                :label="$t('quotation_item_new_install_search')"
                                single-line
                                hide-details
                                clearable
                              ></v-text-field>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.RemoveItem.InstallPosition`]="{ item }">
                            {{ turnData(item.RemoveItem.InstallPosition) }}
                          </template>
                        </v-data-table>
                        <!-- 驗收完成工單 -->
                        <v-data-table
                          :headers="acceptanceWorkItemDataTableHeaders"
                          :items="editedEngineerWork.EngineerWorkItems"
                          class="elevation-1 my-5 mx-5"
                          :search="searchWorkItems"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          v-if="editedEngineerWork.NumberType === 8"
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title>{{
                                $t('engineer_item_repair_item_return_title')
                              }}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="searchWorkItems"
                                append-icon="mdi-magnify"
                                :label="$t('quotation_item_new_install_search')"
                                single-line
                                hide-details
                                clearable
                              ></v-text-field>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.ReturnItem.InstallPosition`]="{ item }">
                            {{ turnData(item.ReturnItem.InstallPosition) }}
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row>
                        <v-col cols="2" v-for="fixImage in fixImageList" :key="fixImage">
                          <v-card flat>
                            <v-img :src="fixImage"></v-img>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          v-for="repairImage in repairImageList"
                          :key="repairImage"
                        >
                          <v-card flat class="photo-card">
                            <v-img
                              :src="repairImage"
                              aspect-ratio="1"
                              class="grey lighten-2 photo-thumbnail"
                              @click="openPreviewImage(repairImage)"
                            >
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-dialog v-model="isShowPreviewImageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card class="preview-dialog-card d-flex flex-column">
                          <v-card-title class="pa-2 flex-grow-0">
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="isShowPreviewImageDialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-card-text class="pa-2 d-flex align-center justify-center flex-grow-1 preview-image-container" @click.self="isShowPreviewImageDialog = false">
                            <img
                              :src="previewImageSrc"
                              class="preview-image"
                            />
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                      <v-data-table
                        :headers="inCarItemDataTableHeaders"
                        :items="inCarItemList"
                        class="elevation-1 my-5 mx-5"
                        :search="searchInCarItem"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                        :header-props="headerProps"
                        :item-class="isOutOfWarrantyInCarClass"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchInCarItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.InstallPosition`]="{ item }">
                          {{ turnData(item.InstallPosition) }}
                        </template>
                        <template v-slot:[`item.BuyOrRentType`]="{ item }">
                          {{ turnBuyOrRentType(item.BuyOrRentType) }}
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item value="tab-5">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.TpAccount"
                                  label="環保帳號"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.TpPassword"
                                  label="環保密碼"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeLookEngineerWork">
                      {{ $t('common_close') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.Look`]="{ item }">
            <v-icon class="mr-2" @click="isShowWatchEngineerWorkDialogBtn(item)">
              mdi-eye
            </v-icon>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            {{ methodsStatus(item) }}
          </template>
          <template v-slot:[`item.NumberType`]="{ item }">
            {{ turnNumberTypeName(item.NumberType) }}
          </template>
          <template v-slot:[`item.SpecialNeedList`]="{ item }">
            {{ turnSpecialNeedName(item.SpecialNeedList) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
.yellow {
  background-color: yellow !important;
}
.preview-dialog-card {
  background: rgba(0, 0, 0, 0.9);
}
.preview-image-container {
  overflow: auto;
}
.preview-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  touch-action: pinch-zoom;
}
.photo-thumbnail {
  cursor: pointer;
}
.photo-card {
  border: 1px solid #e0e0e0;
}
</style>
<script>
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePicker from '@/components/DatePicker.vue'
import {
  HttpEngineerWork,
  HttpFix,
  HttpRepair,
  HttpInstallationAcceptance,
  HttpInstallPosition
} from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { NumberType } from '@/js/NumberType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { WorkType } from '@/js/WorkType'
export default {
  components: { CustomerAutocompleteFilter, DatePicker },
  name: 'EngineerWorkDone',
  props: {
    maintenanceEngineers: {
      type: Array
    },
    allSpecialNeedList: {
      type: Array
    },
    headerProps: {
      type: Object
    },
    tabTitle: {
      type: String
    }
  },
  data: () => ({
    searchWorkItems: '',
    isDoneLoading: false,
    doneList: [],
    filterWorkDone: {
      LicensePlate: '',
      CustomerId: '',
      MaintenanceEngineer: '',
      StartTime: 0,
      EndTime: 0,
      SpecialNeedId: ''
    },
    isShowWatchEngineerWorkDialog: false,
    editedEngineerWorkIndex: -1,
    editedEngineerWork: {
      NumberType: 8,
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      FixType: 0,
      CarPlace: '',
      LicensePlate: '',
      Point: 0,
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      IsDone: false,
      DoneTime: 0,
      EngineerWorkItems: [],
      FixNumber: '',
      FileNameList: [],
      FixFileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: ''
    },
    defaultEngineerWork: {
      NumberType: 8,
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      FixType: 0,
      CarPlace: '',
      LicensePlate: '',
      Point: 0,
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      IsDone: false,
      DoneTime: 0,
      EngineerWorkItems: [],
      FixNumber: '',
      FileNameList: [],
      FixFileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: ''
    },
    searchInCarItem: '',
    fixImageList: [],
    repairImageList: [],
    isShowPreviewImageDialog: false,
    previewImageSrc: '',
    inCarItemList: [],
    installPositionList: []
  }),
  async mounted () {
    await this.getDoneWork()
    await this.getInstallPositionList()
  },
  watch: {
    async tabTitle (val) {
      if (val === 'tab-3') {
        await this.getDoneWork()
      }
    }
  },
  computed: {
    engineerDoneWorkDataTableHeaders () {
      return [
        { text: this.$t('engineer_number_type'), align: 'start', value: 'NumberType' },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_car_place'),
          align: 'start',
          value: 'CarPlace'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        {
          text: this.$t('installation_notice_point'),
          align: 'start',
          value: 'Point'
        },
        { text: this.$t('installation_notice_else_point'), align: 'start', value: 'ElsePoint' },
        { text: this.$t('fix_reason'), align: 'start', value: 'FixReason' },
        { text: this.$t('common_look'), align: 'center', value: 'Look', sortable: false }
      ]
    },
    tabOneTitle () {
      if (this.editedEngineerWork.NumberType === 9) {
        return this.$t('engineer_name_one')
      } else {
        return this.$t('engineer_name_two')
      }
    },
    turnDate () {
      return this.convertToDateTimeFormat(this.editedEngineerWork.CreateTime)
    },
    turnDoneTime () {
      return this.convertToDateTimeFormat(this.editedEngineerWork.DoneTime)
    },
    inCarItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'BomName',
          sortable: false
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'ItemName',
          sortable: false
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType',
          sortable: false
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'end',
          value: 'InstallPosition',
          sortable: false
        },
        {
          text: this.$t('bom_item_quantity'),
          align: 'end',
          value: 'Quantity',
          sortable: false
        },
        {
          text: this.$t('engineer_is_out_of_warranty'),
          align: 'end',
          value: 'IsOutOfWarranty',
          sortable: false
        }
      ]
    },
    acceptanceWorkItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'ReturnItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'ReturnItem.Name' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'ReturnItem.RealQuantity'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'ReturnItem.OriginalSerialNumber'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'ReturnItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'ReturnItem.IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'ReturnItem.InstallPosition'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    removeWorkItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'RemoveItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'RemoveItem.Name' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'RemoveItem.RealQuantity'
        },
        {
          text: this.$t('engineer_item_original_serial_numbers'),
          align: 'start',
          value: 'RemoveItem.OriginalSerialNumber'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'RemoveItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'RemoveItem.IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'RemoveItem.InstallPosition'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    workItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'RemoveItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'RemoveItem.Name' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'RemoveItem.RealQuantity'
        },
        {
          text: this.$t('engineer_item_original_serial_numbers'),
          align: 'start',
          value: 'RemoveItem.OriginalSerialNumber'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'RemoveItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'RemoveItem.IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'RemoveItem.InstallPosition'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'RemoveItem.WorkType'
        },
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'ReturnItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'ReturnItem.Name' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'ReturnItem.RealQuantity'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'ReturnItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'ReturnItem.IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'ReturnItem.InstallPosition'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'ReturnItem.WorkType'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    async setDoneFilterCustomer (val) {
      this.filterWorkDone.CustomerId = val.Id
      this.filterWorkDone = JSON.parse(JSON.stringify(this.filterWorkDone))
    },
    isOutOfWarrantyClass (item) {
      if (item.RemoveItem.IsOutOfWarranty && item.RemoveItem.BuyOrRentType === 1) {
        return 'red'
      }
      if (item.RemoveItem.IsPersonalFactor) {
        return 'yellow'
      }
    },
    isOutOfWarrantyInCarClass (item) {
      if (item.IsOutOfWarranty && item.BuyOrRentType === 1) {
        return 'red'
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setStartDoneTime (val) {
      this.filterWorkDone.StartTime = val * 1
    },
    setEndDoneTime (val) {
      this.filterWorkDone.EndTime = val * 1
    },
    async getDoneWork () {
      this.isDoneLoading = true
      let response = await HttpEngineerWork.GetDoneWork({
        customerId: this.filterWorkDone.CustomerId,
        licensePlate: this.filterWorkDone.LicensePlate,
        maintenanceEngineer: this.filterWorkDone.MaintenanceEngineer,
        startTime: this.filterWorkDone.StartTime,
        endTime: this.filterWorkDone.EndTime,
        specialNeedId: this.filterWorkDone.SpecialNeedId
      })
      this.doneList = response.status === 200 ? response.data.Data : []
      this.isDoneLoading = false
    },
    async isShowWatchEngineerWorkDialogBtn (item) {
      this.editedEngineerWorkIndex = this.doneList.indexOf(item)
      this.editedEngineerWork = JSON.parse(JSON.stringify(item))
      await this.getFixPhoto()
      await this.getPhoto()

      if (
        this.editedEngineerWork.NumberType === 9 &&
        this.editedEngineerWork.FixType !== 1 &&
        this.editedEngineerWork.FixType !== 2 &&
        this.editedEngineerWork.FixType !== 12
      ) {
        let response = await HttpEngineerWork.UpdateIsOutOfRepairWarranty(item)
        this.editedEngineerWork = response.status === 200 ? response.data.Data : {}
        await this.getCarItem()
      }
      this.isShowWatchEngineerWorkDialog = true
    },
    async closeLookEngineerWork () {
      this.isShowWatchEngineerWorkDialog = false
      this.$nextTick(() => {
        this.editedEngineerWork = JSON.parse(JSON.stringify(this.defaultEngineerWork))
        this.editedEngineerWorkIndex = -1
      })
      await this.getDoneWork()
    },
    async getCarItem () {
      let response = await HttpEngineerWork.GetItemInCar({
        customerId: this.editedEngineerWork.CustomerId,
        licensePlate: this.editedEngineerWork.LicensePlate
      })
      this.inCarItemList = response.status === 200 ? response.data.Data : []
    },
    async getFixPhoto () {
      if (
        this.editedEngineerWork.FixFileNameList &&
        this.editedEngineerWork.FixFileNameList.length > 0
      ) {
        let response = await HttpFix.GetImage({
          fixNumber: this.editedEngineerWork.FixNumber,
          fixFileList: this.editedEngineerWork.FixFileNameList.join(',')
        })
        this.fixImageList = response.status === 200 ? response.data.Data : []
      }
    },
    openPreviewImage (src) {
      this.previewImageSrc = src
      this.isShowPreviewImageDialog = true
    },
    async getPhoto () {
      if (this.editedEngineerWork.FileNameList && this.editedEngineerWork.FileNameList.length > 0) {
        let response
        if (this.editedEngineerWork.NumberType === 9) {
          response = await HttpRepair.GetImage({
            repairNumber: this.editedEngineerWork.Number,
            repairFileList: this.editedEngineerWork.FileNameList.join(',')
          })
        } else {
          response = await HttpInstallationAcceptance.GetImage({
            acceptanceNumber: this.editedEngineerWork.Number,
            acceptanceFileList: this.editedEngineerWork.FileNameList.join(',')
          })
        }

        this.repairImageList = response.status === 200 ? response.data.Data : []
      }
    },
    methodsStatus (value) {
      if (!value.IsAccept) {
        return this.$t('installation_acceptance_status_is_accept')
      } else if (value.IsAccept && !value.IsDone) {
        return this.$t('installation_acceptance_status_accept')
      } else if (value.IsDone && !value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_status_done')
      } else {
        return this.$t('installation_acceptance_status_is_accept')
      }
    },
    turnNumberTypeName (val) {
      return NumberType.NumberTypeName(val)
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnWorkTypeName (val) {
      return WorkType.getFormWorkTypeName(val)
    }
  }
}
</script>
